export default __webpack_public_path__ + "images/0f9a4d15d401b58b5c2ac54a9db69600-speedy-cart.svg";